module.exports = __webpack_public_path__ + "img/forgot_password.de5c957a.svg";